<template>
  <div
    v-if="service.suspended === false && service.discontinued === false"
    class="atom-result mt-3"
  >
    <div
      v-if="service.tarifId === 'TarifSIM' || service.tarifId === 'TarifMelita'"
    >
      <div
        v-for="item in this.parameters.filter(pr => !pr.hidden)"
        :key="item.name"
      >
        <div v-if="item.service === 'sim'" class="mb-3 atom-result__row d-flex">
          <span class="label-fixed gray-text mr-2">
            {{ $t("LABEL-" + item.name) }}
          </span>
          <span>{{ item.value }}</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        v-for="item in this.parameters.filter(pr => !pr.hidden)"
        :key="item.name"
      >
        <div
          v-if="item.service === 'default'"
          class="mb-3 atom-result__row d-flex"
        >
          <span v-if="!item.label" class="label-fixed gray-text mr-2">
            {{ $t("LABEL-" + item.name) }}
          </span>
          <span v-else class="label-fixed gray-text mr-2">
            {{ $t(item.label) }}
          </span>
          <span>
            {{ item.value }}
            <span v-if="item.valueAddText">
              {{ $t(item.valueAddText) }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    service: Object
  },
  data() {
    return {
      /**
       * here define all counters which have to be shown
       *
       * service used for condition in parameter showing
       * unlimitedIfZero means that we show text "unlimited" if value is 0
       * customProcess name of condition to switch to the custom process of value catch
       */
      parameters: [
        {
          service: "sim",
          name: "DATA_SIM_COUNT",
          value: 0,
          unlimitedIfZero: false
        },
        {
          service: "sim",
          name: "DATA_SIM_CONNECTION_TECHNOLOGY",
          value: 0,
          unlimitedIfZero: false
        },
        {
          service: "sim",
          name: "DATA_SIM_POOLING_PLAN",
          value: 0,
          unlimitedIfZero: false
        },
        {
          service: "sim",
          name: "DATA_SIM_METHOD_TRANSMISSION",
          value: 0,
          unlimitedIfZero: false
        },
        {
          service: "default",
          name: "OUT_MSG_LMT_SYS",
          value: 0,
          unlimitedIfZero: true,
          valueAddText: "den"
        },
        {
          service: "default",
          name: "IN_MSG_LMT_SYS",
          value: 0,
          unlimitedIfZero: true,
          valueAddText: "den"
        },
        {
          service: "default",
          name: "DEVICES_COUNT",
          value: 0,
          unlimitedIfZero: false,
          customProcess: "devicesCount"
        },
        {
          service: "default",
          name: "DEV_LMT_ACTUAL",
          value: 0,
          unlimitedIfZero: true
        },
        {
          service: "default",
          name: "PREREGISTRATION_DAYS",
          label: "COUNTER-PREREGISTRATION_DAYS",
          value: 0,
          hideIfZero: true,
          isNotCounter: true
        },
        {
          service: "default",
          name: "PREREGISTRATION_MSGS",
          label: "COUNTER-PREREGISTRATION_MSGS",
          value: 0,
          hideIfZero: true,
          isNotCounter: true
        }
      ]
    };
  },
  watch: {
    service: function() {
      this.getLimits();
    }
  },
  mounted() {
    this.getLimits();
  },
  methods: {
    getLimits() {
      if (this.service.parameters) {
        for (const param of this.parameters) {
          // some values has to be processed manually
          if (param.customProcess) {
            if (param.customProcess == "devicesCount") {
              param.value = this.service.devices.count;
            }
          } else {
            let paramName = `COUNTER-${param.name}`;
            if (param.isNotCounter) {
              paramName.replace("COUNTER-", "");
            }
            let v = this.service.parameters.filter(
              param => param.name === paramName
            )[0];

            if (v) {
              param.value = v.value;
            }

            if (param.value == 0 && param.unlimitedIfZero) {
              param.value = this.$t("neomezene");
            }

            if (param.value == 0 && param.hideIfZero) {
              param.hidden = true;
            }
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.atom-result__row span {
  font-size: 15px;
}

.atom-result__row .label-fixed {
  width: 180px !important;
}
</style>
